import React from 'react';
import {Modal, Table} from 'react-bootstrap';
import {useIntl, FormattedMessage} from 'react-intl';
import {SessionListingDatum, SessionPersonReference} from './PaperSubmissionSessionListing';

type PaperSubmissionSessionModalProps = {
    session: SessionListingDatum | null,
    onHide: Function
};

/**
 * Modal zur Anzeige der Session-Details
 *
 * @constructor
 * @param session
 * @param onHide
 */
const PaperSubmissionSessionModal: React.FC<PaperSubmissionSessionModalProps> = ({session, onHide}) => {
    const intl = useIntl();

    const renderOtherPersons = (personReferences: SessionPersonReference[]): JSX.Element[] => {
        const result: JSX.Element[] = [];
        for (const personReference of personReferences) {
            result.push(
                <div key={personReference.id}>
                    {[
                        personReference.salutation,
                        personReference.firstName,
                        personReference.lastName,
                        `(${personReference.role[intl.locale]})`
                    ]
                    .filter(entry => !!entry)
                    .join(' ')}
                </div>
            );
        }
        return result;
    }

    return <Modal show={!!session}
                  onHide={onHide}
                  size="lg"
                  dialogClassName='papersubmission-session-modal'>
            <Modal.Header closeButton>
                <Modal.Title>
                    {session?.session.title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Table>
                    <tbody>
                        {!!session?.session.subTitle &&
                            <tr>
                                <td><FormattedMessage id="myarea.listing.modal.label.subtitle" />:</td>
                                <td>{session?.session.subTitle}</td>
                            </tr>
                        }
                        <tr>
                            <td><FormattedMessage id="myarea.listing.modal.label.teasertext" />:</td>
                            <td>{session?.session.teasertext}</td>
                        </tr>
                        {!!session?.session.personReferences.length &&
                            <tr>
                                <td><FormattedMessage id="myarea.listing.modal.label.persons" />:</td>
                                <td>{renderOtherPersons(session?.session.personReferences)}</td>
                            </tr>
                        }
                        <tr>
                            <td><FormattedMessage id="myarea.listing.modal.label.topic" />:</td>
                            <td>{session?.session.topic[intl.locale]}</td>
                        </tr>
                        {!!session?.session.themes?.length &&
                            <tr>
                                <td><FormattedMessage id="myarea.listing.modal.label.themes" />:</td>
                                <td>{session?.session.themes.map(theme => theme[intl.locale]).join(', ')}</td>
                            </tr>
                        }
                        {!!session?.session.eventSeries?.length &&
                            <tr>
                                <td><FormattedMessage id="myarea.listing.modal.label.eventSeries" />:</td>
                                <td>{session?.session.eventSeries.join(', ')}</td>
                            </tr>
                        }
                        <tr>
                            <td><FormattedMessage id="myarea.listing.modal.label.agendaType" />:</td>
                            <td>{session?.session.agendaType}</td>
                        </tr>
                    </tbody>
                </Table>
            </Modal.Body>
        </Modal>;
};

export default PaperSubmissionSessionModal;
